$(() => {
  const pagesProjectComingSoonNotification = {
    container: null,
    btn: null,
    btn_container: null,
    title: null,
    subtitle: null,
    description: null,
    counter: null,
    project_id: null,

    init() {
      this.container = $('#comingSoonSection');
      this.btn = $('.coming-soon-btn');
      this.btn_container = $('.coming-soon-btn-container');
      this.title = $('.coming-soon-title > span');
      this.subtitle = $('.coming-soon-subtitle > span');
      this.description = $('.coming-soon-description');
      this.counter = $('#coming-soon-register-count');
      this.project_id = $('#project_id').val();

      const counterCount = Number(this.counter.attr('data-count'));
      this.notificationCount =
        Number.isFinite(counterCount) && counterCount >= 0 ? counterCount : 0;

      const self = this;
      window.Geenie.ComingSoonNotification.getIsRegistered(
        self.project_id,
      ).done(data => {
        if (data.is_already_coming_soon_registered) {
          self.render(data);
        }
      });
      // APIへアクセスして、CSRFトークンをCOOKIEに保存する
      window.Geenie.Csrf.fetch_token();

      return this;
    },
    bind() {
      this.btn.on('click', { self: this }, e => {
        const { self } = e.data;
        self.register(self.project_id);
        e.preventDefault();
      });
      return this;
    },
    unbind() {
      this.btn.off('click');
      return this;
    },
    incrementNotificationCount() {
      this.counter.text(this.notificationCount + 1);
    },
    register(projectId) {
      const self = this.unbind();
      const promise = window.Geenie.ComingSoonNotification.create(projectId);
      promise
        .done(data => {
          if (!data.is_logined) {
            window.location.href = `/login/?ref=${encodeURIComponent(
              window.location.href,
            )}`;
          }
          self.render(data);
          self.incrementNotificationCount();
          self.unbind();
        })
        .fail(() => {
          self.bind();
          // eslint-disable-next-line no-alert
          alert(
            '通信に失敗しました。お手数ですが、少し時間をあけて再度実行してください。',
          );
        });
    },
    render(data) {
      const self = this;
      if (data.is_already_coming_soon_registered) {
        // カミングスーンの通知を受け取るに設定した時
        if (this.notificationCount === 0) {
          // 件数がキャッシュされているので、登録済みだが0件の場合は1件に更新する
          this.incrementNotificationCount();
        }
        self.container.addClass('fade-out');
        setTimeout(() => {
          self.btn.addClass('disabled');
          if (data.remain_text) {
            self.title.text(`開始まであと${data.remain_text}`);
          }
          if (data.start_date) {
            const time = new Date(data.start_date * 1000);
            const minutes = time.getMinutes().toString().padStart(2, '0');
            const text = `${
              time.getMonth() + 1
            }月${time.getDate()}日 ${time.getHours()}時${minutes}分 予定`;
            self.subtitle.text(text);
          }
          self.btn.text('登録済み');
          self.description.html(
            `${self.description.html()}<br>登録の確認・解除は<a href="/my/coming-soon-notifications" onclick="window.Geenie?.ClickTracking?.sendClickEvent?.('coming_soon_notifications');">アカウント設定</a>で行ってください。`,
          );
          self.container.removeClass('fade-out');
          self.container.addClass('fade-in');
        }, 250);
        self.container.removeClass('fade-in');
      }
    },
  };
  pagesProjectComingSoonNotification.init().bind();
});
